// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.userinfo {
    color: white;
}
.navbar {
    margin-left: 1em;
}

.logoutButton {
    color: rgb(88, 0, 0);
    border: none;
    font-weight: bold;
    font-size: 1.1em;
    min-width: 100px;
    padding: 0.2em;
    border-radius: .5em;
    background-color: rgb(255, 255, 255);
}

.navUsername {
    color: rgb(8, 70, 19);
    margin-right: 0.5em;
    border: none;
    font-weight: bold;
    font-size: 1.1em;
    padding: 0.2em;
    border-radius: .5em;
    background-color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/components/navbar.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,oCAAoC;AACxC","sourcesContent":[".userinfo {\n    color: white;\n}\n.navbar {\n    margin-left: 1em;\n}\n\n.logoutButton {\n    color: rgb(88, 0, 0);\n    border: none;\n    font-weight: bold;\n    font-size: 1.1em;\n    min-width: 100px;\n    padding: 0.2em;\n    border-radius: .5em;\n    background-color: rgb(255, 255, 255);\n}\n\n.navUsername {\n    color: rgb(8, 70, 19);\n    margin-right: 0.5em;\n    border: none;\n    font-weight: bold;\n    font-size: 1.1em;\n    padding: 0.2em;\n    border-radius: .5em;\n    background-color: rgb(255, 255, 255);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
